<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-16 10:58:24
 * @FilePath: /wemeet-admin-new/src/views/marketing/lotteryManage.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <el-tabs v-model="activeName" class="demo-tabs">
      <el-tab-pane label="奖品管理" name="first">
        <vab-query-form>
          <vab-query-form-left-panel :span="12">
            <el-button plain type="info" @click="goBack">返回</el-button>
          </vab-query-form-left-panel>

          <vab-query-form-right-panel :span="12">
            <el-button type="primary" @click="handleSend()">添加奖品</el-button>
          </vab-query-form-right-panel>
        </vab-query-form>
        <el-table v-loading="listLoading" border :data="list">
          <el-table-column label="奖品名称" prop="name" show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.name ? row.name : '/' }}
            </template>
          </el-table-column>
          <el-table-column label="每日限额" prop="dailyLimit" show-overflow-tooltip />
          <el-table-column label="奖品图片" prop="imgUrl" show-overflow-tooltip>
            <template #default="{ row }">
              <el-image class="vab-data-empty" :preview-src-list="[row.imgUrl]" :src="row.imgUrl" />
            </template>
          </el-table-column>
          <el-table-column label="中奖概率（0-1）" prop="probability" show-overflow-tooltip />
          <el-table-column label="库存" prop="stock" show-overflow-tooltip />

          <el-table-column label="操作" show-overflow-tooltip width="420">
            <template #default="{ row }">
              <el-button plain type="info" @click="handleSend(row)">编辑</el-button>
              <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
              <el-button plain type="success" @click="seeDetail(row)">查看</el-button>
            </template>
          </el-table-column>
          <template #empty>
            <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
            <el-empty class="vab-data-empty" description="暂无奖品" />
          </template>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="积分管理" name="second">
        <pointsManage />
      </el-tab-pane>
    </el-tabs>

    <addLottery
      ref="addLotteryRef"
      :meeting-code="queryForm.meetingCode"
      :meeting-type="queryForm.meetingType"
      @fetch-data="queryData"
    />
    <LotteryList ref="lotteryListRef" :meeting-code="queryForm.meetingCode" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { useRoute } from 'vue-router'
  import { getPrizesList, delPrizes } from '@/api/exhibitionManage'
  import addLottery from './components/addLottery.vue'
  import LotteryList from './components/LotteryList.vue'
  import pointsManage from './pointsManage.vue'
  export default defineComponent({
    name: 'LotteryManage',
    components: {
      addLottery,
      LotteryList,
      pointsManage,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {},
        activeName: 'first',
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        addgroupDrawer: null,
        chooseVal: [],
        importRef: null,
        addLotteryRef: null,
        lotteryListRef: null,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            await delPrizes(row.id, state.queryForm.meetingCode)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        try {
          const { data } = await getPrizesList(state.queryForm)
          state.list = data
        } catch (e) {
          state.listLoading = false
          state.list = []
        }
        state.listLoading = false
      }

      onMounted(() => {
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.meetingType = route.query.type || 'EXHIBITION'
        fetchData()
      })

      const handleSend = (row) => {
        state.addLotteryRef.handleOpen(row)
      }

      const goBack = () => {
        proxy.$router.go(-1)
      }
      const seeDetail = (row) => {
        state.lotteryListRef.handleOpen(row)
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleDelete,
        handleConfig,
        Delete,
        Search,
        Plus,
        handleSend,
        goBack,
        seeDetail,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
